angular
  .module('resources.Category', ['ngResource'])
  .factory('Category', ['$resource', function ($resource) {
    var Resource = $resource('/api/account/categories/:id', {id: '@_id'}, {
      query: {
        method: 'GET',
        isArray: false
      },
      getTree: {
        method: 'GET',
        url: '/api/account/categoriesTree',
        isArray: true
      },
      getPermittedTree: {
        method: 'GET',
        url: '/api/account/categoriesPermittedTree',
        isArray: true
      },
    });

    return Resource;
  }]);



// WEBPACK FOOTER //
// ./client/src/common/resources/Category.js